import { render, staticRenderFns } from "./MoreOperation.vue?vue&type=template&id=20900262&scoped=true&"
import script from "./MoreOperation.vue?vue&type=script&lang=js&"
export * from "./MoreOperation.vue?vue&type=script&lang=js&"
import style0 from "./MoreOperation.vue?vue&type=style&index=0&id=20900262&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20900262",
  null
  
)

export default component.exports